/**
 * ランクティア（スキルランク）の色・ラベル定数（付録C 実測値）
 *
 * ⚠️ 単一の真実はサーバの `skill_rank_tiers.color`。
 * ここで定義する値はあくまで **表示フォールバック / モック用**。
 * TierObject に color が含まれる場合は常にサーバ値を優先すること。
 *
 * 参照: ゲーミフィケーション機能_設計書.md §8-6 / 付録C.1 / 付録F.3
 */

// ランクティアの code（rookie..platinum, sort_order 0-4）
export type RankTierCode = 'rookie' | 'bronze' | 'silver' | 'gold' | 'platinum';

// code -> 代表色（付録C.1 seed 値）
export const RANK_TIER_COLORS: Record<RankTierCode, string> = {
  rookie:   '#57A665',
  bronze:   '#B7553C',
  silver:   '#BDC2C4',
  gold:     '#EEB812',
  platinum: '#8095A8',
};

// code -> ハイライト色（3D グラデーション再現用・任意）
export const RANK_TIER_HIGHLIGHT_COLORS: Record<RankTierCode, string> = {
  rookie:   '#90D59B',
  bronze:   '#FFC490',
  silver:   '#D8DCDE',
  gold:     '#F5CE3A',
  platinum: '#E8F0F8',
};

// code -> 日本語ラベル（フォールバック表示用。サーバの name があればそちらを優先）
export const RANK_TIER_LABELS: Record<RankTierCode, string> = {
  rookie:   'ルーキー',
  bronze:   'ブロンズ',
  silver:   'シルバー',
  gold:     'ゴールド',
  platinum: 'プラチナ',
};

// sort_order 順（0=ルーキー 〜 4=プラチナ）
export const RANK_TIER_ORDER: RankTierCode[] = ['rookie', 'bronze', 'silver', 'gold', 'platinum'];

/**
 * code から表示色を取得（フォールバック）。
 * 未知の code はプライマリ灰を返す。
 */
export const getRankTierColor = (code?: string | null): string => {
  if (code && code in RANK_TIER_COLORS) {
    return RANK_TIER_COLORS[code as RankTierCode];
  }
  return '#BDC2C4';
};

/**
 * code から日本語ラベルを取得（フォールバック）。
 */
export const getRankTierLabel = (code?: string | null): string => {
  if (code && code in RANK_TIER_LABELS) {
    return RANK_TIER_LABELS[code as RankTierCode];
  }
  return code || '-';
};
